export function TermsPage() {
  return (
    <article className="mx-auto max-w-2xl py-8">
      <h1 className="text-3xl font-semibold tracking-tight">Terms of Service</h1>
      <p className="mt-1 text-xs uppercase tracking-[0.2em] text-muted-foreground">
        Last updated: April 2026
      </p>

      <p className="mt-8 text-sm text-muted-foreground">
        These are the rules for using fanfix.me. Read them. If you don't agree, don't use the
        site. Using the site means you agree.
      </p>

      <H>Who we are</H>
      <P>
        fanfix.me is a tool that helps creators sell commissioned work and helps clients buy it.
        We are not a party to your contract. The creator and the client are the parties. We run
        the surface where that contract happens.
      </P>

      <H>Your account</H>
      <P>
        You're one human, over 18, using a real email. Don't share your login. Don't let bots
        drive your account. What happens under your account is your problem.
      </P>

      <H>Your content, your copyright</H>
      <P>
        You keep full ownership of the work you make and the work you commission. By posting it
        here you grant us a narrow license: host it, serve it to the other party, show your
        public pages to the public, and nothing else. We don't train AI on it. We don't resell it.
      </P>

      <H>What you can't do here</H>
      <P>
        No minors in sexual contexts, ever. No CSAM of any kind, ever. That's an immediate ban
        and a report.
      </P>
      <P>
        No harassment, doxxing, stalking, hate targeting people for who they are. No threats. No
        using the platform to run scams.
      </P>
      <P>
        No reselling someone else's work as your own. No uploading work you don't have the right
        to upload. No impersonating another artist. See the{" "}
        <a className="underline" href="/ai-policy">AI Policy</a> for the specifics on that.
      </P>
      <P>
        No malware, phishing, account stuffing, scraping the API at volume, or trying to break
        someone else's session. Don't be the reason we have to write more rules.
      </P>

      <H>Commissions and payments</H>
      <P>
        Creators set their own prices, turnaround, and revision rules. Clients book under those
        rules. Deposits book the slot. The final payment unlocks delivery. Payments for now move
        through the creator's external processor; the creator is responsible for their own tax
        and accounting.
      </P>
      <P>
        If a creator doesn't deliver, the client should work it out with the creator first.
        We'll look at disputes on request but we're not a court and we don't hold funds in
        escrow today. Chargebacks are between you and your processor.
      </P>

      <H>Revisions and scope</H>
      <P>
        The revisions allowed by a service are the revisions the client gets. Requests beyond
        that are a new scope and the creator can decline or quote them separately. Arguing about
        round four is not our problem; we just make round four visible before it happens.
      </P>

      <H>Suspension and termination</H>
      <P>
        We can suspend or terminate an account that breaks these rules. Flagrant stuff (CSAM,
        fraud, impersonation) gets you kicked immediately. Borderline stuff gets a warning if we
        feel like giving one.
      </P>
      <P>
        You can delete your account whenever you want. Jobs in flight remain visible to the
        other party until they're closed out, because deleting one side of an active job mid-way
        is a worse outcome than keeping the record.
      </P>

      <H>No warranty</H>
      <P>
        The service is provided as-is. Things break. We push fixes when we can. We do not
        warrant that your commission will be a masterpiece, that your client will pay on time,
        or that the tablet won't die mid-stroke.
      </P>

      <H>Liability</H>
      <P>
        To the extent the law allows, our liability is capped at what you paid us in the last
        twelve months. If you paid us nothing, that's the cap. We are not liable for a
        commission that went sideways between two humans.
      </P>

      <H>Changes</H>
      <P>
        We can change these terms. Material changes get a notice on next login and a fresh date
        at the top. If you keep using the site after that, you're on the new terms.
      </P>

      <H>Contact</H>
      <P>
        <a className="underline" href="mailto:legal@fanfix.me">legal@fanfix.me</a>
      </P>
    </article>
  );
}

function H({ children }: { children: React.ReactNode }) {
  return <h2 className="mt-10 mb-2 text-lg font-semibold tracking-tight">{children}</h2>;
}
function P({ children }: { children: React.ReactNode }) {
  return <p className="mb-3 text-sm leading-relaxed text-muted-foreground">{children}</p>;
}
